import api from '../../app/api';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
const GoogleAuth = props => {
  const clientId = "555863894030-amh034rgil4frbe2n10lgpk9vhb5ljvo.apps.googleusercontent.com";

  return (
   <GoogleOAuthProvider clientId={clientId}>
     <GoogleLogin
      width={250}
      size="large"
      onSuccess={async credentialResponse => {
        props.setLoading(true);
        await api.post(
          '/auth/google',
          {},
          {
            headers: {
              Authorization: `Bearer ${credentialResponse.credential}`
            },
            withCredentials: true
          }
        ).then((r) => {
          if (r.status === 202) {
            props.setLoading(false);
            props.setMfaDetails(r.data)
            props.setShowMfa(true);
          } else {
            const userDecoded = jwtDecode(credentialResponse.credential);
            props.handleLoggedIn();
            props.handleEmailUpdate(userDecoded.email);
            props.handleNameUpdate(userDecoded.given_name);
            props.handleSurnameUpdate(userDecoded.family_name);
            api.get('/api/profiles/data')
            .then((response) => {
              if (response.status === 200 && response.data.selectedProfile !== undefined) {
                props.handleSave(response.data);
                props.setLoading(false);
              } else {
                api.post('/api/profiles/data',
                {
                  selectedProfile: {id:props.profile.id, name:props.profile.name, yearCalc: props.profile.yearCalc},
                  income: props.income.records,
                  expenses: props.expenses.records,
                  debt: props.debt,
                  descriptions: [...props.income.descriptions, ...props.expenses.descriptions, ...props.debt.descriptions],
                  profiles: []
                }
              )
              .then((postResponse) => {
                props.handleSave(postResponse.data);
                props.setLoading(false);
                return true;
              })
              .catch((error) => {
                props.setErrorTitle("Failed to get save data");
                props.setErrorMessage("An error accurred whilst saving your data. Please try again.");
                props.setErrorShow(true);
                props.setLoading(false);
              })
            }
            })
            .catch((error) => {
              props.setErrorTitle("Failed to get your data");
              props.setErrorMessage("An error accurred whilst fetching your data. Please try again.");
              props.setErrorShow(true);
              props.setLoading(false);
            });
          }      
        })
        .catch((err) => {
          console.error('Login Failed, catch', err);
          props.setErrorTitle("Google Login Failed");
          props.setErrorMessage("An error occurred during Google login. Please try again.");
          props.setErrorShow(true);
          props.setLoading(false);
        });
      }}
      onError={() => {
        console.error('Login Failed, onError');
        props.setErrorTitle("Google Login Failed");
        props.setErrorMessage("An error occurred during Google login. Please try again.");
        props.setErrorShow(true);
        props.setLoading(false);
      }}
    />
   </GoogleOAuthProvider>
   );
 };
export default GoogleAuth;